/* eslint-disable eqeqeq */
import { TableBody, TableContainer, Table, TableHead, TableRow, TableCell, ButtonGroup, Tooltip, Button, TextField } from "@mui/material";
import React, { useCallback, useRef } from "react";
import AirFTReview, { TruckFTReview } from "../commons/fuelTicketPreview.component";
import PDFInvoiceViewer from "../commons/pdfInvoiceViewer.component";
import { useEffect } from "react";
import { useState } from "react";
import moment from "moment";
import { FT_TYPE_REPLACE_URL, statusColor } from "../../config";
import { useTranslation } from "react-i18next";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import { DeleteDialog } from "../../commons/dialog.component";
import PrintIcon from "@mui/icons-material/Print";
import DeleteIcon from "@mui/icons-material/Delete";
import RepeatOneIcon from "@mui/icons-material/RepeatOne";
import { useHistory, useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { approveFT, deleteFuelTicket, getAcsreg, getFlight, getFuelTicket } from "../../../services/api";
import { FilterBy } from "../../commons/filter.component";
import { useSelector } from "react-redux";
import { toHttpsURL } from "../../../services/libService";

const cols = ["Hàng hoá", "Số lượng", "Đơn vị tính", "Nhiệt độ", "Tỷ trọng", "d15", "lit", "vcf", "wcf", "l15", "kg"];
export default function FuelTicketDetail({ type = 0, onUpdate, id }) {
  //type = 0 thi khong hien pdf ma hien detail
  // hook
  const printRef = useRef();
  const history = useHistory();
  const location = useLocation();
  const [t] = useTranslation();
  const handlePrint = useReactToPrint({ content: () => printRef.current });
  // state
  const [data, setData] = useState("");
  const renderDetail = useCallback(() => {
    if (!data) return;
    switch (data.ft_type) {
      case 2:
        return <TruckDetail data={data} />;
      case 3:
        return <TruckDetail data={data} />;
      default:
        return <AirDetail data={data} />;
    }
  }, [data]);
  const renderApproveForm = useCallback(() => {
    if (!data || data.status === "DELETED") return;
    switch (data.ft_type) {
      case 2:
        return <TruckApproveForm data={data} onApprove={handleApprove} />;
      case 3:
        return <TruckApproveForm data={data} onApprove={handleApprove} />;
      default:
        return <AirApproveForm data={data} onApprove={handleApprove} />;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  const renderReview = useCallback(() => {
    if (!data) return;
    switch (data.ft_type) {
      case 2:
        return <TruckFTReview data={data} printRef={printRef} />;
      case 3:
        return <TruckFTReview data={data} printRef={printRef} />;
      default:
        return <AirFTReview data={data} printRef={printRef} />;
    }
  }, [data]);
  // method
  const handleDeleteAction = () => {
    return deleteFuelTicket(data.id);
  };
  const handleDeleteResponse = (res) => {
    res.code === 200 && setData((prev) => ({ ...prev, status: "DELETED" }));
    onUpdate && onUpdate(res, { ...data, status: "DELETED" });
  };
  const handleApprove = (res) => {
    res.code === 200 && setData(res.data);
    onUpdate && onUpdate(res, res.data);
  };
  // effect
  useEffect(() => {
    setData(null);
    if (!id) return;
    if (isNaN(parseInt(id))) return history.push(`/fuelticket${location.search}`);
    getFuelTicket(id).then((res) => res.code === 200 && setData(res.data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  if (data)
    return (
      <div>
        <div style={{ justifyContent: "right", display: "flex", backgroundColor: "#b3deff", alignItems: "center" }}>
          <ButtonGroup style={{ height: 50 }}>
            <Tooltip title="In">
              <Button variant="outlined" color="primary" onClick={handlePrint}>
                <PrintIcon />
              </Button>
            </Tooltip>
            {!["DELETED", "ISSUED"].includes(data.status) && FT_TYPE_REPLACE_URL[data.ft_type] && (
              <Tooltip title="Phát hành thay thế">
                <Button variant="outlined" color="primary" onClick={() => history.push({ pathname: `${FT_TYPE_REPLACE_URL[data.ft_type]}/${data.id}`, state: data })}>
                  <RepeatOneIcon />
                </Button>
              </Tooltip>
            )}
            {!["DELETED", "ISSUED"].includes(data.status) && (
              <Tooltip title="Huỷ">
                <ButtonWithAPICall variant="outlined" api={handleDeleteAction} dialogNode={(params) => <DeleteDialog {...params} />} response={handleDeleteResponse}>
                  <DeleteIcon />
                </ButtonWithAPICall>
              </Tooltip>
            )}
          </ButtonGroup>
        </div>
        <div style={{ display: "flex", width: "100%" }}>
          <div style={{ width: "calc(100% - 320px)", marginRight: "auto" }}>
            {type === 0 ? (
              <>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", textTransform: "uppercase" }}>
                  <h2>THÔNG TIN FUELTICKET SỐ: {data.id}</h2>
                  &nbsp;
                  <h2 className={`status ${data?.status}`} style={{ color: statusColor[data?.status] }}>
                    {t(data?.status)}
                  </h2>
                </div>
                <div align="left" style={{ marginBottom: 0 }}>
                  <b>{t("Thông tin cơ bản")}</b>:
                </div>
                {renderDetail()}
                <div align="left" style={{ margin: "10px 0 0" }}>
                  <b>{t("Thông tin hàng hóa")}:</b>
                </div>
                <TableContainer style={{ borderTop: "1px solid gray", borderBottom: "1px solid gray", margin: "10px 0" }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        {cols.map((item, index) => (
                          <TableCell key={index} align="center">
                            {item}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell align="center">{data.product_name}</TableCell>
                        <TableCell align="center">{Math.round(data.gallon).toLocaleString()}</TableCell>
                        <TableCell align="center">{data.productunit_code}</TableCell>
                        <TableCell align="center">{data.temp && parseFloat(data.temp).toFixed(2)}</TableCell>
                        <TableCell align="center">{data.density && parseFloat(data.density).toFixed(4)}</TableCell>
                        <TableCell align="center">{data.d15 && parseFloat(data.d15).toFixed(4)}</TableCell>
                        <TableCell align="center">{Math.round(data.lit).toLocaleString()}</TableCell>
                        <TableCell align="center">{data.vcf && parseFloat(data.vcf).toFixed(4)}</TableCell>
                        <TableCell align="center">{data.wcf && parseFloat(data.wcf).toFixed(4)}</TableCell>
                        <TableCell align="center">{Math.round(data.l15).toLocaleString()}</TableCell>
                        <TableCell align="center">{Math.round(data.kg).toLocaleString()}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                {renderApproveForm()}
              </>
            ) : (
              <PDFInvoiceViewer src={toHttpsURL(data.pdf)} />
            )}
          </div>

          <div style={{ width: "300px" }}>{renderReview()}</div>
        </div>
      </div>
    );
  else return "";
}

const AirDetail = ({ data }) => {
  return (
    <TableContainer>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell align="left">Theo SO số: {data.saleorder}</TableCell>
            <TableCell align="left">Theo hoá đơn GTGT số: {data?.invoice_code}</TableCell>
            <TableCell align="left">Chứng chỉ số: {data.cert_no}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="left">Ngày phát hành: {data.valid_date && moment(data.valid_date).format("DD/MM/YYYY")}</TableCell>
            <TableCell align="left">Giờ bắt đầu: {data.start_pump && moment(data.start_pump).format("HH:mm")}</TableCell>
            <TableCell align="left">Giờ kết thúc: {data.end_pump && moment(data.end_pump).format("HH:mm")}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="left">Khách hàng: {data.customer_name}</TableCell>
            <TableCell align="left" colSpan={2}>
              Mã số thuế: {data.customer_tax}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="left" colSpan={3}>
              Địa chỉ: {data.customer_address}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="left" colSpan={3}>
              Xuất bán từ kho: {data.inventory_name}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="left">Số chuyến bay: {data.flight_no}</TableCell>
            <TableCell align="left" colSpan={2}>
              Tuyến bay: {data.route}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="left">Loại máy bay: {data.aircraft_type}</TableCell>
            <TableCell align="left" colSpan={2}>
              A/C Reg: {data.acsreg}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const TruckDetail = ({ data }) => {
  return (
    <TableContainer>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell align="left">Kho xuất: {data.inventory_name}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="left">Thời gian bắt đầu: {data.start_pump && moment(data.start_pump).format("HH:mm")}</TableCell>
            <TableCell align="left">Thời gian kết thúc: {data.end_pump && moment(data.end_pump).format("HH:mm")}</TableCell>
            {/* <TableCell align='left'>Ngày phát hành: {dataState.valid_date && moment(dataState.valid_date).format('DD/MM/YYYY')}</TableCell> */}
          </TableRow>
          <TableRow>
            <TableCell align="left">Phương tiện: {data.refueler_license_plate}</TableCell>
            <TableCell align="left" colSpan={2}>
              Người điều khiển: {data.driver}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="left" colSpan={1}>
              Chứng chỉ kho xuất số: {data.cert_no}
            </TableCell>
            <TableCell align="left" colSpan={2}>
              Phiếu nhập/Ký hiệu: {data.ext_inv_serial}
            </TableCell>
          </TableRow>
          <TableRow></TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
const TruckApproveForm = ({ onApprove, data }) => {
  // hook
  const [t] = useTranslation();
  const [input, setInput] = useState({
    note: data.note || "",
    sourcing: null,
  });
  const api = () => {
    const object = {
      note: input.note,
      sourcing: input.sourcing?.id,
    };
    return approveFT(data.id, object);
  };
  return (
    <div>
      <div align="left" style={{ margin: "10px 0" }}>
        <b>{t("Thông tin duyệt phiếu")}:</b>
      </div>
      <div>
        <FilterBy
          label={t("Nguồn hàng")}
          style={{ display: "inline-flex", width: 240, margin: "5px 10px" }}
          getDataFunc={() =>
            Promise.resolve({
              data: [
                { id: 22, label: "Goverment Consignment" },
                { id: 24, label: "Customer Consignment" },
              ],
              code: 200,
            })
          }
          setDefaultFunc={(option) => setInput((prev) => ({ ...prev, sourcing: option.find((item) => item.id == data.sourcing) }))}
          triggerSetDefaultFunc={true}
          value={input.sourcing}
          onChange={(e, newValue) => setInput((prev) => ({ ...prev, sourcing: newValue }))}
          getOptionLabel={(option) => option.label}
        />
        <TextField
          style={{ display: "inline-flex", width: 240, margin: "5px 10px" }}
          label={t("Ghi chú")}
          value={input.note}
          onChange={(e) => setInput((prev) => ({ ...prev, note: e.target.value }))}
        />
      </div>
      <div style={{ margin: 10 }}>
        <ButtonWithAPICall variant="contained" api={api} response={onApprove}>
          {t("Duyệt")}
        </ButtonWithAPICall>
      </div>
    </div>
  );
};
const AirApproveForm = ({ onApprove, data }) => {
  // hook
  const user = useSelector((state) => state.user.data);
  const [t] = useTranslation();
  const [input, setInput] = useState({
    flight: null,
    aircraft: null,
    acsreg: null,
    saleorder: null,
    note: data.note || "",
    sourcing: null,
  });
  const api = () => {
    const object = {
      flight_id: input.flight?.id,
      flight_no: input.flight?.flight_no,
      route: input.flight?.route,
      acsreg_id: input.acsreg?.id,
      note: input.note,
      sourcing: input.sourcing?.id,
    };
    return approveFT(data.id, object);
  };
  return (
    <div>
      <div align="left" style={{ margin: "10px 0" }}>
        <b>{t("Thông tin duyệt phiếu")}:</b>
      </div>
      <div>
        <FilterBy
          label={t("Số chuyến bay")}
          style={{ display: "inline-flex", width: 240, margin: "5px 10px" }}
          getDataFunc={() => getFlight({ status: 1, organization_id: user?.organization_id })}
          setDefaultFunc={(option) => setInput((prev) => ({ ...prev, flight: option.find((item) => item.id === data.flight_id) }))}
          triggerSetDefaultFunc={true}
          triggerGetDataFunc={Boolean(user)}
          value={input.flight}
          getOptionLabel={(option) => `${option.id} - ${option.flight_no}` || ""}
          onChange={(e, newValue) => setInput((prev) => ({ ...prev, flight: newValue }))}
        />
        <FilterBy
          label="Đăng bạ tàu bay"
          style={{ display: "inline-flex", width: 240, margin: "5px 10px" }}
          getDataFunc={() => getAcsreg({ status: 1 })}
          getDataDependencies={[input.customer]}
          setDefaultFunc={(option) => setInput((prev) => ({ ...prev, acsreg: option.find((item) => item.id == data.acsreg_id) }))}
          triggerSetDefaultFunc={true}
          value={input.acsreg}
          onChange={(e, newValue) => setInput((prev) => ({ ...prev, acsreg: newValue }))}
          getOptionLabel={(option) => `${option.id} - ${option.code}`}
        />
        <TextField
          style={{ display: "inline-flex", width: 240, margin: "5px 10px" }}
          label={t("Ghi chú")}
          value={input.note}
          onChange={(e) => setInput((prev) => ({ ...prev, note: e.target.value }))}
        />
        <FilterBy
          label={t("Nguồn hàng")}
          style={{ display: "inline-flex", width: 240, margin: "5px 10px" }}
          getDataFunc={() =>
            Promise.resolve({
              data: [
                { id: 22, label: "Goverment Consignment" },
                { id: 24, label: "Customer Consignment" },
              ],
              code: 200,
            })
          }
          setDefaultFunc={(option) => setInput((prev) => ({ ...prev, sourcing: option.find((item) => item.id == data.sourcing) }))}
          triggerSetDefaultFunc={true}
          value={input.sourcing}
          onChange={(e, newValue) => setInput((prev) => ({ ...prev, sourcing: newValue }))}
          getOptionLabel={(option) => option.label}
        />
      </div>
      <div style={{ margin: 10 }}>
        <ButtonWithAPICall variant="contained" api={api} response={onApprove}>
          {t("Duyệt")}
        </ButtonWithAPICall>
      </div>
    </div>
  );
};
